import { alpha, makeStyles, Theme } from "@material-ui/core";

interface Props {
  position?: number;
  height?: number;
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
  root: ({ position, height }) =>
    position && height
      ? {
          display: "block",
          position: "absolute",
          top: 0,
          left: position ? position - 2 : 0,
          height: height,
          width: "4px",
          backgroundColor: alpha(theme.palette.primary.main, 0.5),
          zIndex: 2,
          boxShadow: `0px 0px 12px ${theme.palette.primary.main}`,
        }
      : {},
}));

export const TimeOfDayIndicator = (props: Props) => {
  const classes = useStyles(props);

  return <div className={classes.root}></div>;
};
